import { useLang } from 'hooks/lang';

import { FullProjectInvoice } from 'entities';

import { Row, IconButton } from 'components/Blocks';

import { ExpandIcon, ReceiptLongIcon } from 'components/Icons';

import { ProjectInvoiceMenu } from './Menu';

interface ProjectInvoiceOptionsProps {
  children?: never;
  projectInvoice: FullProjectInvoice;
  open: () => void;
  openInvoice?: () => void;
}

export function ProjectInvoiceOptions({
  projectInvoice,
  open,
  openInvoice,
}: ProjectInvoiceOptionsProps) {
  const { t } = useLang();

  return (
    <Row justifyContent="flex-end" gap="2">
      <ProjectInvoiceMenu projectInvoice={projectInvoice} />

      {openInvoice && (
        <IconButton tooltipContent={t('view-invoice') as string} onClick={openInvoice}>
          <ReceiptLongIcon />
        </IconButton>
      )}

      <IconButton tooltipContent={t('open')} onClick={open}>
        <ExpandIcon />
      </IconButton>
    </Row>
  );
}
